export default __webpack_public_path__ + "static/media/gallery_04.551e4fa4.jpg";